export default {
  about: {
    subtitle1: "About Us",

    title1: "Welcome to",
    title2: "MAHAL Food Marketplace",

    // Third line
    from: "Your",
    highlight: "Trusted Marketplace",

    desc:
      "MAHAL is a trusted B2B food sourcing platform connecting restaurants with verified suppliers through transparency, quality, and reliability.",

    text:
      "At MAHAL, we are redefining food supply chain management by enabling seamless ordering, transparent pricing, and long-term partnerships all within one smart and scalable platform.",

    f1: "Verified Organic Products",
    f2: "Healthy & Fresh Supply",
    f3: "Locally Sourced Produce",
    f4: "Quality You Can Trust",

    cta1: "Learn More",
    cta2: "Contact Us",
  },
};